import GlobalMixin from '@/app/shared/mixins/global';

const mapFiltersMixins = {
    mixins: [
        GlobalMixin,
    ],
    props: {
        moduleCode: {
            type: String,
            required: true,
            default: null
        },
        // initialOpen: {
        //     type: Boolean,
        //     default: false
        // },
        aside: {
            type: Boolean,
            default: false
        },
        asideCss: {
            type: String,
            default: ''
        },
        asideCssHeader: {
            type: String,
            default: ''
        },
        asideCssBody: {
            type: String,
            default: ''
        },
        asideExpanded: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            map: null,
        }
    },
    computed: {
        ctrlPanel(){
            return this.$store.getters.getPanel(this.moduleCode, this.idPanel);
        },
        isPanelActive(){
            return this.$store.getters.isPanelActive(this.moduleCode, this.idPanel);
        },
        isPanelVisible(){
            return this.$store.getters.isPanelVisible(this.moduleCode, this.idPanel);
        },
        showPanel() {
            return this.isPanelActive && this.isPanelVisible;
        },
        collapsed() {
            return !!this.ctrlPanel.collapsed;
        },
        initialOpen() {
            return !!this.ctrlPanel.initialOpen;
        },
        isActionMap() {
            return this.$store.getters[`${this.moduleCode}/getActionMap`] != null;// MAP_ACTIONS.NEW_OCCURRENCE;
        },
    },
    methods: {
        openPanel(){
            return this.$store.dispatch(`${this.moduleCode}/openPanel`, this.idPanel);
        },
        closePanel(){
            return this.$store.dispatch(`${this.moduleCode}/closePanel`, this.idPanel);
        },
        filterOccurrenceByStatusAndType: function(tp, id) {
            this.$store.dispatch(`${this.moduleCode}/toggleFilterMap`, {'tp': tp, 'id': id});
        },
    },
};

export default mapFiltersMixins;